import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { TECHNOLOGY_CARDS } from "@/data/technologyCards";

const testCode = (code) => code.toLowerCase().replace(".", "-");

export const TechnologyExplorer = () => {
  const [activeCode, setActiveCode] = useState(TECHNOLOGY_CARDS[0].code);
  const active = TECHNOLOGY_CARDS.find((item) => item.code === activeCode) || TECHNOLOGY_CARDS[0];

  return (
    <div data-testid="technology-image-atlas" className="border-2 border-primary bg-background">
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-px bg-primary/20" role="group" aria-label="Select a technology to explore">
        {TECHNOLOGY_CARDS.map((item) => {
          const selected = item.code === activeCode;
          const code = testCode(item.code);
          return (
            <div key={item.code} data-testid={`tech-card-${code}`} className="contents">
              <button
                type="button"
                title={item.name}
                aria-label={`${item.code}: ${item.name}`}
                aria-pressed={selected}
                onPointerDown={() => setActiveCode(item.code)}
                onClick={() => setActiveCode(item.code)}
                data-testid={`technology-tab-${code}`}
                className={`group relative aspect-square min-w-0 touch-manipulation overflow-hidden transition-opacity ${selected ? "opacity-100" : "opacity-70 hover:opacity-100"}`}
              >
                <img
                  src={item.image}
                  alt=""
                  data-testid={`technology-thumbnail-${code}`}
                  className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.04]"
                  loading="lazy"
                />
                <span className={`absolute inset-0 bg-gradient-to-t from-foreground via-transparent to-transparent ${selected ? "ring-inset ring-4 ring-accent" : ""}`} aria-hidden />
                <span className="absolute inset-x-0 bottom-0 p-3 font-mono text-xs font-bold uppercase tracking-[0.12em] text-white">
                  {item.code}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 border-t-2 border-primary">
        <motion.div key={active.image} initial={{ opacity: 0.45 }} animate={{ opacity: 1 }} className="lg:col-span-9 aspect-[5/4] sm:aspect-[4/3] overflow-hidden bg-foreground">
          <img
            src={active.image}
            alt={active.imageAlt}
            data-testid={`technology-image-${testCode(active.code)}`}
            className="h-full w-full object-contain object-center"
            loading="lazy"
          />
        </motion.div>

        <div data-testid="technology-active-detail" className="lg:col-span-3 bg-primary text-white p-6 md:p-8 flex flex-col justify-center">
          <div className="font-mono text-xs uppercase tracking-[0.14em] text-white/55">{active.code}</div>
          <div className="mt-2 w-fit border border-white/35 px-2 py-1 font-mono text-xs uppercase tracking-[0.1em] text-white/75">{active.badge}</div>
          <h3 className="mt-5 font-display text-2xl font-bold leading-tight text-white">{active.name}</h3>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">{active.line}</p>
          <Link to={active.href} data-testid="technology-active-link" className="mt-8 inline-flex w-fit border border-white/40 px-5 py-3 font-mono text-xs uppercase tracking-[0.12em] text-white hover:bg-white hover:text-primary transition-colors">
            Learn More →
          </Link>
        </div>
      </div>
    </div>
  );
};